<template>
  <div id="data-view">
    <dv-full-screen-container>

      <video width="2048" height="1080" autoplay loop muted preload
          style="width= 100%; height=100%; object-fit: fill; position: absolute;top: 0px;left:0px;z-index: -2;filter: blur(2px);filter: brightness(0.6);">
          <source src="../../assets/bg.mp4" type="video/mp4">
          您的浏览器不支持Video标签。
      </video>
        
      <div class="main-header">
        <div class="mh-left">
          <div style="width: 255px; height: 80px; line-height: 80px; text-align:center;margin-left:20px;">
            <router-link to="/system">
              <img src="../../assets/logocw.png" height="80" width="240" alt="hexagon" />
            </router-link>
          </div>
        </div>

        <div class="mh-middle">
          <dv-decoration-8 style="height:70px;margin-bottom: 5px;" />
          <div style="margin: auto;display: block;">

            <div style=" width: 100%;  display: flex  ">
              <div style="margin: 0 auto;">黑灯工厂OEE系统平台</div>
            </div>
            <div style=" width: 100%;  display: flex  ">
              <div style="margin: 0 auto;">SMU OEE Monitor Platform</div>
            </div>
            <dv-decoration-5 style="width:350px;height:50px;" />
          </div>
          <dv-decoration-8 :reverse="true" style="height:70px;margin-bottom: 5px;" />
        </div>

        <div class="mh-right">
          <!--div style="width: 180px; height: 80px; line-height: 50px; text-align:center;margin-left:50px;">机床1</div-->
          <div style="float:right; width: 240px; height: 100px; line-height: 10px; text-align:center;cursor: pointer; display: flex;   justify-content: flex-end ;   align-items: flex-end;">
            <div style="margin-right: 20px;      align-items: flex-end;">
              <img src="../../assets/quanping.png" style="width: 25px;height: 25px;" @click="requestFullscreen()" v-if="full===false">
              <img src="../../assets/suoxiao.png" style="width: 25px;height: 25px;" @click="exitFullScreen()" v-if="full===true">
            </div>
            <dv-decoration-11 style="width:200px;height:100px;      align-items: flex-end;">
              <span v-on:click="MachineClick('0e885c8cf67711eba6c5cc4a900f0425')"
                v-if="showID == '54f8aa82f67b11eba548cc4a900f0425'">

                <img src="../../assets/cnca.png" height="100" width="150" alt="hexagon" />
              </span>

              <span v-on:click="MachineClick('54f8aa82f67b11eba548cc4a900f0425')"
                v-if="showID == '0e885c8cf67711eba6c5cc4a900f0425'">

                <img src="../../assets/cncb.png" height="100" width="150" alt="hexagon" />
              </span>
            </dv-decoration-11>

          </div>
        </div>
      </div>

      <dv-border-box-1 class="main-container">
        <div class="right-main-container">
          <dv-border-box-7 class="rm-top-container">

            <dv-border-box-8 class="rmctc-right-container" :dur=30>
              <div class="chart-table">
                <!-- <OEE-Charts :oee=0.3 :chartname="'asdf'" /> -->
                <div class="item oeechart">
                  <OEE-Charts :oee="oee" :chartname="'OEE'" :shap="1" />
                </div>
                <div class="item">
                  <OEE-Charts :oee="timeOee" :chartname="'时间开动率'" :chartname_E="'Availability'" :shap="2" />
                </div>
                <div class="item">
                  <OEE-Charts :oee="performanceOee" :chartname="'性能开动率'" :chartname_E="'Performance'" :shap="2" />
                </div>
              </div>
            </dv-border-box-8>

            <dv-border-box-9 class="rmctc-left-container">
              <div class="left-chart">
                <div class="left-chart-item">
                  <Right-Chart-1 :qty="qty" :total="total" :planStop="planStop" :realTime="realTime" :qualifiedRatio="qualifiedRatio" />
                </div>
                <div class="left-chart-item">
                  <Right-Chart-2 :partsnumber="parts"/>
                </div>
              </div>
            </dv-border-box-9>
          </dv-border-box-7>
          <!--bottom--->
          <div class="rm-bottom-container">
            <dv-border-box-3 class="rm-bottom22">
              <Bode-Charts :gatt="gantt"/>
            </dv-border-box-3>
          </div>
        </div>
      </dv-border-box-1>

    </dv-full-screen-container>
  </div>
</template>

<script>
import CenterCmp from './CenterCmp'
import RightChart1 from './RightChart1'
import RightChart2 from './RightChart2'
import BottomCharts from './BottomCharts'
import OEECharts from './OEECharts'
import BodeCharts from './BodeCharts'

export default {
  name: 'DataView',
  components: {
    CenterCmp,
    RightChart1,
    RightChart2,
    BottomCharts,
    BodeCharts,
    OEECharts
  },
  data() {
    return {
      refreshTime: 30,
      showID: '54f8aa82f67b11eba548cc4a900f0425',//0e885c8cf67711eba6c5cc4a900f0425
      urlqty: 'http://42.194.135.254:10095/oee/qty',
      urlgantt: 'http://42.194.135.254:10095/oee/gantt/',
      urltotal: 'http://42.194.135.254:10095/oee/total/',
      urlplanStop: 'http://42.194.135.254:10095/oee/planStop/',
      urlrealTime: 'http://42.194.135.254:10095/oee/realTime',
      urlqualifiedRatio: 'http://42.194.135.254:10095/oee/qualifiedRatio/',
      urloee: 'http://42.194.135.254:10095/oee/oee/',
      urlTimeOee:"http://42.194.135.254:10095/oee/timeOeeEx/",
      urlPerformanceOee:'http://42.194.135.254:10095/oee/performanceOee/',
      urlparts: 'http://42.194.135.254:10095/work/parts',
      urlfinishedparts: 'http://42.194.135.254:10095/oee/finishedPartsEx/',
      qty: 0,
      gantt: [],
      parts:[],
      total: 0,
      planStop: 0,
      realTime: 0,
      qualifiedRatio: 0,
      oee: 0,
      timeOee:0,
      performanceOee:0,
      full : false
    }
  },
  mounted() {
    let _this = this;
    this.$data.refreshTime = this.$cookies.get('refreshTime')

    if (this.$data.refreshTime == null) {
      this.$data.refreshTime = 30;
      this.$cookies.set('refreshTime', 30)
    }

    this.$data.showID = this.$cookies.get('showID')

    if (this.$data.showID == null) {
      this.$data.showID = '54f8aa82f67b11eba548cc4a900f0425';
      this.$cookies.set('showID', '54f8aa82f67b11eba548cc4a900f0425')
    }
    else if (this.$data.showID != '54f8aa82f67b11eba548cc4a900f0425' && this.$data.showID != '0e885c8cf67711eba6c5cc4a900f0425') {
      this.$data.showID = '54f8aa82f67b11eba548cc4a900f0425';
    }


    let interval = this.$data.refreshTime * 1000;
    _this.load();
    this.timer =
      setInterval(() => {
        _this.load();
      }, interval);

    console.log('完成了数据加载');
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    console.log('全都销毁了');
  },
  methods: {
    load() {

      let _this = this;
      var date = new Date();
      var date2 = new Date(new Date().valueOf()+1000*60*60*24);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var dates = date.getDate();

      var t_year = date2.getFullYear();
      var t_month = date2.getMonth() + 1;
      var t_dates = date2.getDate();

      let f_date = year + '-' + (month<=9 ? '0' + month : month) + '-' + (dates <=9 ? '0' + dates : dates)
      let t_date = t_year + '-' + (t_month<=9 ? '0' + t_month : t_month)  + '-' + (t_dates <=9 ? '0' + t_dates : t_dates)
      let f_f_date = year + '-' + (month<=9 ? '0' + month : month) + '-' + (dates <=9 ? '0' + dates : dates)
      let f_t_date = t_year + '-' + (t_month<=9 ? '0' + t_month : t_month) + '-' + (t_dates <=9 ? '0' + t_dates : t_dates)


      let foee_f_date = year + '-' + (month<=9 ? '0' + month : month) + '-' + (dates <=9 ? '0' + dates : dates)
      let foee_t_date = year + '-' + (month<=9 ? '0' + month : month) + '-' + (dates <=9 ? '0' + dates : dates)

      console.log("*********",f_f_date,"********",f_t_date)
      let machine = this.$data.showID

      //-----------------------------
      //-----------------------------
      //-----------------------------
      this.$http.get(this.$data.urlqty, {
        params: { f_date, t_date, machine }
      })
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.$data.qty = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 甘特图
      this.$http.get(this.$data.urlgantt, {
        params: { f_date:foee_f_date, t_date:foee_t_date, machine }
      })
        .then(function (response) {
          console.log("甘特图")
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.$data.gantt = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 所有零件列表
      this.$http.get(this.$data.urlparts, {
        params: { f_date:f_f_date, t_date: f_t_date}
      })
        .then(function (response) {
          console.log("完成零件列表")
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.parts.splice(0,_this.parts.length);
          response.data.forEach((e) => {
            _this.parts.push(
              [e.productCode +  "_" + e.productName, e.qty]
            )
          })
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 完成零件列表
        this.$http.get(this.$data.urlfinishedparts, {
        params: { f_date:f_f_date, t_date: f_t_date ,machine}
      })
        .then(function (response) {
          console.log("完成零件列表")
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.parts.splice(0,_this.parts.length);
          response.data.forEach((e) => {
            _this.parts.push(
              [e.productCode ,e.productName, e.count]
            )
          })
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      this.$http.get(this.$data.urltotal, {
        params: { f_date, t_date }
      })
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.$data.total = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      this.$http.get(this.$data.urlplanStop, {
        params: { f_date, t_date }
      })
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.$data.planStop = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 实际工作时间
      this.$http.get(this.$data.urlrealTime, {
        params: { f_date, t_date }
      })
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.$data.realTime = Number(response.data.toFixed(2));
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 合格率
      this.$http.get(this.$data.urlqualifiedRatio, {
        params: { f_date, t_date }
      })
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          _this.$data.qualifiedRatio = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // oee
      this.$http.get(this.$data.urloee, {
        params: { f_date:f_f_date, t_date:f_t_date, machine }
      })
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)


          _this.$data.oee = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })
      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 时间开动率
        this.$http.get(this.$data.urlTimeOee, {
        params: { f_date:f_f_date, t_date:f_t_date, machine }
      })
        .then(function (response) {
          console.log("时间开动率")
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)


          _this.$data.timeOee = response.data
        })
        .catch(function (error) {
          console.log(error)
        })

      //-----------------------------
      //-----------------------------
      //-----------------------------
      // 性能开动率
        this.$http.get(this.$data.urlPerformanceOee, {
        params: { f_date, t_date, machine }
      })
        .then(function (response) {
          console.log("性能开动率")
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)


          _this.$data.performanceOee = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    MachineClick(ID) {
      this.$data.showID = ID
      this.$cookies.set('showID', ID)
      this.load()
    },
    requestFullscreen () {
      this.full = true
      const docElm = document.documentElement
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
    },
    exitFullScreen () {
      this.full = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },
  }
}

</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-header {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .mh-left {
      font-size: 20px;
      color: rgb(1, 134, 187);

      a:visited {
        color: rgb(1, 134, 187);
      }
    }

    .mh-middle {
      font-size: 19px;
      width: 840px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

    }

    .mh-left,
    .mh-right {
      width: 400px;
    }
  }

  .main-container {
    height: calc(~"100% - 100px");

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-chart-container {
    width: 22%;
    padding: 10px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
  }

  .right-main-container {
    width: 100%;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .rm-bottom-container {
    height: 50%;
    display: flex;
  }

  .rmctc-left-container {
    width: 66%;
  }
  .left-chart{
    width:100%;
    display: grid;
    grid-template-columns: 60% 40%;

  }
  .rm-bottom22 {
    width: 100%;
  }

  .rmctc-right-container {
    width: 34%;
  }

  .chart-table {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(3, 1fr);
    //grid-gap: 2px;
    // grid-gap: 1px solid #37a2da;
  }

  .item {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .oeechart {
    grid-area: span 2 / span 2;
  }

  .rm-top-container {
    height: 50%;
  }

  .rmctc-chart-1,
  .rmctc-chart-2 {
    height: 50%;
  }
}
</style>
